import Modal from "antd/lib/modal";
import { IResponseError } from "../models/base";
import { ISpinLuckyWheelModel } from "../models/eventModel";
import EventRepositories from "../repositories/event";
import React from "react";

const handleError = (error: IResponseError) => {
  if (!error) {
    return;
  }
  let msg = "Lỗi";

  switch (error.code) {
    case "ERROR_EVENT_CUSTOMER_OUT_OF_SPIN":
      msg = "Quý khách đã hết lượt quay đối với mã đơn hàng này!";
      break;
    default:
      msg = error.code;
      break;
  }

  Modal.error({
    title: "Lỗi",
    content: <div>{msg}</div>,
    onOk() {},
  });
};

const getEventLuckyWheel = async () => {
  const response = await EventRepositories.getEventLuckyWheel();
  if (!response?.data) {
    return null;
  }
  return response.data;
};

const validateOrder = async (eventId: string, model: ISpinLuckyWheelModel) => {
  const response = await EventRepositories.validateOrder(eventId, model);
  if (response?.error) {
    handleError(response.error);
    return;
  }
  if (!response?.data) {
    return null;
  }
  return response.data;
};

const getEventLuckyWheelSummary = async (
  eventId: string,
  storeCode: string,
  lastId?: string
) => {
  const response = await EventRepositories.getLuckyWheelSummary(
    eventId,
    storeCode,
    lastId
  );

  if (!response?.data) {
    return null;
  }
  return response.data;
};

const getEventSettings = async () => {
  const response = await EventRepositories.getEventSettings();

  if (!response?.data) {
    return null;
  }
  return response.data;
};

const getEventGifts = async (eventId: string, storeCode: string) => {
  const response = await EventRepositories.getEventGifts(eventId, storeCode);

  if (!response?.data) {
    return null;
  }
  return response.data;
};

const getEventStores = async () => {
  const response = await EventRepositories.getEventStores();

  if (!response?.data) {
    return null;
  }
  return response.data;
};

const getLuckyWheelPrizes = async (eventId: string, storeCode: string) => {
  const response = await EventRepositories.getLuckyWheelPrizes(
    eventId,
    storeCode
  );
  if (!response?.data) {
    return null;
  }
  return response.data;
};

const spinLuckyWheel = async (eventId: string, model: ISpinLuckyWheelModel) => {
  const response = await EventRepositories.spinLuckyWheel(eventId, model);
  if (response?.error) {
    handleError(response.error);
    return;
  }
  if (!response?.data) {
    return null;
  }
  return response.data;
};

const EventServices = {
  getEventSettings,
  validateOrder,
  getEventLuckyWheel,
  getEventLuckyWheelSummary,
  getLuckyWheelPrizes,
  getEventGifts,
  getEventStores,
  spinLuckyWheel,
};

export default EventServices;
